// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-classes-ClassCardMForm-ClassCardMForm-module__mainBox--jGynG {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
/*# sourceMappingURL=ClassCardMForm.module.css.map */`, "",{"version":3,"sources":["webpack://./ClassCardMForm.module.less","webpack://./src/pages/classes/ClassCardMForm/ClassCardMForm.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;ACCF;AACA,oDAAoD","sourcesContent":[".mainBox {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n",".mainBox {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n/*# sourceMappingURL=ClassCardMForm.module.css.map */"],"sourceRoot":""}]);
// Exports
export var mainBox = `src-pages-classes-ClassCardMForm-ClassCardMForm-module__mainBox--jGynG`;
export default ___CSS_LOADER_EXPORT___;
